import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { getExchangeDisplayTask, getExchangeTaskFamily } from './exchangeTaskIdentity';

export interface TaskDisplayGroup {
  displayTask: AutopilotTaskDto;
  tasks: AutopilotTaskDto[];
}

const shouldGroupTask = (task: AutopilotTaskDto) =>
  getExchangeTaskFamily(task.category?.taskType) !== undefined;

const getTaskGroupKey = (task: AutopilotTaskDto) =>
  [task.campaignId, task.contractId ?? '', getExchangeTaskFamily(task.category?.taskType)].join(
    ':'
  );

export const getTaskDisplayGroups = (tasks: AutopilotTaskDto[]): TaskDisplayGroup[] => {
  const groups: TaskDisplayGroup[] = [];
  const groupIndexes = new Map<string, number>();

  for (const task of tasks) {
    if (!shouldGroupTask(task) || !task.campaignId) {
      groups.push({ displayTask: task, tasks: [task] });
      continue;
    }

    const key = getTaskGroupKey(task);
    const existingGroupIndex = groupIndexes.get(key);

    if (existingGroupIndex === undefined) {
      groupIndexes.set(key, groups.length);
      groups.push({ displayTask: task, tasks: [task] });
      continue;
    }

    const group = groups[existingGroupIndex];
    group.tasks.push(task);

    group.displayTask = getExchangeDisplayTask(group.tasks);
  }

  return groups;
};
